import * as React from 'react';
import ThumbnailFolderSvg from '../../../img/thumbnail-folder.svg';

export type FolderTypeIconProps = Exclude<React.ImgHTMLAttributes<any>, 'src'>;
export const FolderTypeIcon: React.FunctionComponent<FolderTypeIconProps> = ({ ...props }) => <img {...props} src={ThumbnailFolderSvg} />;
